<template>
    <v-container fluid>
        <v-row dense align="baseline">
            <v-col>
                <v-text-field v-model="value.postalCode" clearable dense label="郵便番号" outlined v-mask="maskPostal"/>
            </v-col>
            <v-col>
                <v-btn @click="onClickGetAddress" color="primary"><v-icon>mdi-refresh</v-icon><span v-if="!$vuetify.breakpoint.xs">住所取得</span></v-btn>
            </v-col>
        </v-row>                
        <v-row dense>
            <v-col>
                <v-text-field 
                    v-model="value.pref" 
                    clearable
                    dense
                    label="県名" 
                    outlined 
                    type="text" 
                    counter="50"
                    :rules="[validatorAddressLength]" />
            </v-col>
            <v-col>
                <v-text-field 
                    v-model="value.city" 
                    clearable 
                    dense
                    label="市名" 
                    outlined 
                    type="text" 
                    counter="50"
                    :rules="[validatorAddressLength]" />
            </v-col>
        </v-row>                
        <v-row dense>
            <v-col>
                <v-text-field 
                    v-model="value.address1" 
                    clearable label="住所1" 
                    dense
                    outlined 
                    type="text" 
                    counter="50"
                    :rules="[validatorAddressLength]" />
            </v-col>
        </v-row>                
        <v-row dense>
            <v-col>
                <v-text-field 
                    v-model="value.address2" 
                    clearable 
                    dense
                    label="住所2"
                    outlined 
                    type="text" 
                    counter="50"
                    :rules="[validatorAddressLength]" />
            </v-col>
        </v-row>                
        <v-row dense>
            <v-col>
                <v-select
                    v-model="value.areaID" 
                    clearable 
                    dense
                    label="地域(気象データ対象地域)"
                    :items="areas"
                    :item-text="item => item.pref + item.city"
                    item-value="area"
                    outlined >
                </v-select>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {mask} from 'vue-the-mask';
    import db from '@/firebase/firestore.js'
    export default {
        /**
         * プロパティ
         */
        props: {
            /** 住所 */
            value: {
                type: Object,
                default: function () {
                    return {
                        /** 郵便番号 */
                        postalCode: "",
                        /** 都道府県名 */
                        pref: "",
                        /** 市名 */
                        city: "",
                        /** 住所1 */
                        address1: "",
                        /** 住所2 */
                        address2: "",
                        /** 地域 */
                        areaID: ""
                    }
                }
            }
        },
        /**
         * ディレクティブ
         */
        directives: {
            mask
        },
        /**
         * データ
         */
        data: function () {
            return {
                maskPostal: "###-####",
                validatorRequire: value => !!value || '必須入力です。',
                validatorIDLengthMin: value => value.length >= 8 || '8～12文字の範囲で入力して下さい。',
                validatorIDLengthMax: value => value.length <= 12 || '8～12文字の範囲で入力して下さい。',
                validatorIDCharPattern: value => /^[a-zA-Z0-9._-]+$/.test(value) || 'IDには英数字と._-が使用出来ます。',
                validatorAddressLength: value => value.length <= 50 || '50文字以内で入力して下さい。',
            }
        },
        /**
         * コンピュート
         */
        computed: {
            areas: function () {
                return this.$store.getters["areas"]
            }
        },
        /**
         * 監視
         */
        watch : {
            "value.pref": function () {
                this.refreshArea()
            },
            "value.city": function () {
                this.refreshArea()
            },
        },
        /**
         * メソッド
         */
        methods: {
            /**
             * 住所取得ボタン押下時
             */
            onClickGetAddress: function () {
                const self = this
                const postalCodeValues = this.value.postalCode.split("-")
                const url = 'https://madefor.github.io/postal-code-api/api/v1/' + postalCodeValues[0] + "/" + postalCodeValues[1] + ".json"
        
                fetch(url).then( response => {
                    return response.json()
                }).then( json => {
                    console.log(json)// json.data.fullAddress
                    self.value.pref = json.data[0].ja.prefecture
                    self.value.city = json.data[0].ja.address1
                    self.value.address1 = json.data[0].ja.address2
                }).catch( (error) => {
                    console.log(error)
                    // this.value = '該当する住所が無いか、正しい形式で入力されていません。' + err
                });
            },
            /**
             * 地域を入力内容に合わせて更新する
             */
            refreshArea: function () {
                console.log("refresh area")
                if (this.value.areaID != "") {
                    return
                }
                const index = this.areas.findIndex((v)=>v.pref==this.value.pref && v.city==this.value.city)
                if (index < 0) {
                    return
                }
                this.value.areaID = this.areas[index].area
            },
        }
    }
</script>
